let routerlist = [{
    path: '/',
    name: 'HOME1',
    component: resolve => (require(['@/views/Home'], resolve)),
    redirect: '/home',
    children: [{
            path: '/home',
            name: 'HOME',
            component: resolve => (require(['@/components/Homepage/Homedetail.vue'], resolve)),
            iconClass: 'm-menu-icon icon1'
        },
        {
            path: '/about',
            name: 'ABOUT US',
            redirect: '/company',
            component: resolve => (require(['@/components/Aboutus/About.vue'], resolve)),
            iconClass: 'm-menu-icon icon2',
            children: [{
                    path: '/company',
                    name: 'Who we are?'
                },
                {
                    path: '/team',
                    name: 'Executive Team'
                },
                {
                    path: '/culture',
                    name: 'Culture/Careers'
                },
                {
                    path: '/honor',
                    name: 'Honor'
                },
                {
                    path: '/exhibition',
                    name: 'Exhibition'
                },
                {
                    path: '/partner',
                    name: 'Partner'
                },
                {
                    path: '/recruit',
                    name: 'Talent recruitment'
                }
            ]
        },
        {
            path: '/product',
            name: 'PRODUCT',
            component: resolve => (require(['@/components/Product/Product.vue'], resolve)),
            iconClass: 'm-menu-icon icon4',
            children: [{
                    path: '/industry',
                    name: 'Industry PCBA'
                },
                // {
                //   path: '/team',
                //   name: 'end product'
                // },
                {
                    path: '/automotive',
                    name: 'Automotive PCBA'
                },
                {
                    path: '/network',
                    name: 'Network PCBA'
                },
                {
                    path: '/energy',
                    name: 'New Energy'
                },
                {
                    path: '/molding',
                    name: 'Injection molding'
                }
            ]
        },
        {
            path: '/news',
            name: 'NEWS',
            component: resolve => (require(['@/components/News/News.vue'], resolve)),
            iconClass: 'm-menu-icon icon4'
        },
        {
            path: '/service',
            name: 'SCRVICES',
            component: resolve => (require(['@/components/Service/Service.vue'], resolve)),
            iconClass: 'm-menu-icon icon4',
            children: [{
                    path: '/storage',
                    name: 'Intelligent storage'
                },
                {
                    path: '/Advantage',
                    name: 'Our strengths'
                }
            ]
        },
        {
            path: '/contact',
            name: 'CONTACT',
            component: resolve => (require(['@/components/Contact/Contact.vue'], resolve)),
            iconClass: 'm-menu-icon icon4'
        },
        // {
        //     path: '/commodity',
        //     name: 'commodity',
        //     component: resolve => (require(['@/components/Commodity/Commodity.vue'], resolve)),
        //     iconClass: 'm-menu-icon icon4'
        //   }
    ]
}]
export default routerlist


// WEBPACK FOOTER //
// ./src/router/en_index.js